import { createSlice } from "@reduxjs/toolkit";
import { tripList } from "../../actions/controlPanel/tripList";
import { converDate } from "../../../utils/converData";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const tripListReducer = createSlice({
  name: "tripList",
  initialState,
  reducers: {
    // clearnodeList: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(tripList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(tripList.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(action.payload) && action.payload.length > 0) {
          state.data = action.payload.map((item) => ({
            ...item,
            EventStartedOn: converDate(item.EventStartedOn),
            EventEndedOn: converDate(item.EventEndedOn),
          }));
        }
      })
      .addCase(tripList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export const { cleartripList } = getCategoriessSlice.actions;
export default tripListReducer.reducer;
